<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.496 3H16.505C18.987 3 21 5.012 21 7.496V16.505C21 18.987 18.988 21 16.504 21H7.496C5.013 21 3 18.988 3 16.504V7.496C3 5.013 5.012 3 7.496 3V3Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.949 6.71301C16.763 6.71401 16.612 6.86501 16.612 7.05101C16.612 7.23701 16.764 7.38801 16.95 7.38801C17.136 7.38801 17.287 7.23701 17.287 7.05101C17.288 6.86401 17.136 6.71301 16.949 6.71301"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5456 9.45443C15.9515 10.8603 15.9515 13.1397 14.5456 14.5456C13.1397 15.9515 10.8603 15.9515 9.45443 14.5456C8.04854 13.1397 8.04854 10.8603 9.45443 9.45443C10.8603 8.04854 13.1397 8.04854 14.5456 9.45443"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
